import axios from '@/http/axios';
import {route} from '@/http/ziggy';

/**
 * Fetch experiment messages.
 *
 * @param {Number} experiment
 * @return {Promise}
 */
export const index = ({experiment}) => axios.get(route('catchers.core.messages.index', {experiment}));

/**
 * Store comment on an artifact dataset.
 *
 * @param {Number} experiment
 * @param {String} message
 * @return {Promise}
 */
export const store = ({experiment, message}) => axios.post(route('catchers.core.messages.store', {experiment}), {content: message});

/**
 * Make the User appear online.
 *
 * @param {Number} experiment
 * @return {Promise}
 */
export const appearOnline = ({experiment}) => axios.put(route('catchers.core.experiments.appear_online', {experiment}));

/**
 * Make the User appear offline.
 *
 * @param {Number} experiment
 * @return {Promise}
 */
export const appearOffline = ({experiment}) => axios.put(route('catchers.core.experiments.appear_offline', {experiment}));

/**
 * Number of catchers online.
 *
 * @param {Number} experiment
 * @return {Promise}
 */
export const countOnlineCatchers = ({experiment}) => axios.get(route('catchers.core.experiments.count_online_catchers', {experiment}))

export default {
  index,
  store,
  appearOnline,
  appearOffline,
  countOnlineCatchers,
}
